export default function LinkError({ message }) {
    return <div className="flex items-center justify-center w-full h-full">
        <span className="whitespace-pre-wrap text-center text-orange-pastel text-xl">{message}</span>
    </div>
}